const LOAD_DETAIL_ASSESSMENT_JOBS           = 'LOAD_DETAIL_ASSESSMENT_JOBS'
const LOAD_DETAIL_ASSESSMENT_JOBS_SUCCESS   = 'LOAD_DETAIL_ASSESSMENT_JOBS_SUCCESS'
const LOAD_DETAIL_ASSESSMENT_JOBS_FAILED    = 'LOAD_DETAIL_ASSESSMENT_JOBS_FAILED'
const UNMOUNT_DETAIL_ASSESSMENT_JOBS        = 'UNMOUNT_DETAIL_ASSESSMENT_JOBS'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const jobsDetailAssessmentReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DETAIL_ASSESSMENT_JOBS:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DETAIL_ASSESSMENT_JOBS_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DETAIL_ASSESSMENT_JOBS_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DETAIL_ASSESSMENT_JOBS:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default jobsDetailAssessmentReducer;